import { Helmet } from "react-helmet-async";
import { useState } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
} from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";
import { get } from "src/utils/networkUtils";

export default function StageLeaderboardPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchParams] = useSearchParams();

  const [load, setLoad] = useState(true);

  const getData = async (page) => {
    try {
      if (searchParams.has("stage_id")) {
        if (page === 0) setLoading(true);
        let stageId = searchParams.get("stage_id");
        const offset = page > 1 ? (page - 1) * 100 : 0;
        const response = await get(
          `/admin/stages/${stageId}/leaderboard?offset=${offset}&limit=${100}`
        );

        if (response.leaderboard.length > 0) {
          setRows([...rows, ...response.leaderboard]);
        } else setLoad(false);

        setLoading(false);
        return true;
      } else {
        navigate("/404");
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  };
  return (
    <>
      <Helmet>
        <title> Stage Leaderboard </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Stage Leaderboard
          </Typography>
        </Stack>

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <InfiniteScroll
              pageStart={0}
              loadMore={getData}
              hasMore={load}
              loader={false}
            >
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Rank</TableCell>
                      <TableCell>User ID</TableCell>
                      <TableCell>Username</TableCell>
                      <TableCell>Coins</TableCell>
                      <TableCell>Custom Prize</TableCell>
                      <TableCell>Points</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.rank}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.userId}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <a href={`/dashboard/profile?user_id=${row.userId}`}>
                            {row.name}
                          </a>
                        </TableCell>

                        <TableCell component="th" scope="row">
                          {row.draftWinnings}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.draftCustomPrizeWinnings}
                        </TableCell>

                        <TableCell component="th" scope="row">
                          {row.score}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </InfiniteScroll>
          )}
        </Card>
      </Container>
    </>
  );
}
